module.exports = __webpack_public_path__ + "black_top_arrow.png";